module.exports = __webpack_public_path__ + "img/img-skin02.6aa08283.jpg";